import { AREA_CODES } from 'src/modules/forms/fields/AreaCodeTextField/components/AreaCodeSelect';

export const hasInternationalPhonePrefix = (digitsOnly: string): boolean => {
    if (!digitsOnly) return false;

    if (digitsOnly.startsWith('521')) return true;

    return Object.values(AREA_CODES).some((area) =>
        digitsOnly.startsWith(area.code.replace('+', ''))
    );
};
